import { Component, ChangeDetectionStrategy, inject, computed } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';

/**
 * Mobile app-shell bottom navigation pill (< 768px). Icon-only tabs:
 * Acasă / Caută / Firme noi / Profil.
 */
@Component({
  selector: 'app-mobile-nav',
  imports: [RouterLink, RouterLinkActive],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <nav class="m-bottomnav" aria-label="Navigare principală">
      <div class="m-bottomnav-inner">
        <a class="nav-item" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" aria-label="Acasă">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 11l9-7 9 7v9a2 2 0 0 1-2 2h-3v-7h-8v7H5a2 2 0 0 1-2-2z"/></svg>
        </a>
        <a class="nav-item" routerLink="/cauta-firme" routerLinkActive="active" aria-label="Caută firme">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>
        </a>
        <a class="nav-item" routerLink="/firme-nou-infiintate" routerLinkActive="active" aria-label="Firme nou înființate">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="8" r="4"/><path d="M2 21c0-4 3.1-7 7-7s7 3 7 7"/><path d="M19 8v6M16 11h6"/></svg>
        </a>
        <a class="nav-item" [routerLink]="profileLink()" routerLinkActive="active" aria-label="Profil">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4.4 3.6-8 8-8s8 3.6 8 8"/></svg>
        </a>
      </div>
    </nav>
  `,
  styles: [`
    :host { display: block; }
    @media (min-width: 768px) { :host { display: none; } }
    .m-bottomnav {
      position: fixed; left: 0; right: 0; bottom: 0; z-index: 50;
      padding: 8px 12px calc(14px + env(safe-area-inset-bottom));
      pointer-events: none;
      background: linear-gradient(to top, var(--bg) 55%, transparent);
    }
    .m-bottomnav-inner {
      background: var(--nav-bg);
      -webkit-backdrop-filter: blur(20px) saturate(180%);
      backdrop-filter: blur(20px) saturate(180%);
      border: 1px solid var(--border); border-radius: 24px; padding: 6px;
      display: grid; grid-template-columns: repeat(4, 1fr); align-items: center; gap: 2px;
      pointer-events: auto; box-shadow: 0 10px 30px rgba(0,0,0,0.3);
    }
    .nav-item {
      display: flex; align-items: center; justify-content: center;
      padding: 12px 4px; border: 0; background: transparent; border-radius: 14px;
      color: var(--text-subtle);
      cursor: pointer; text-decoration: none;
      transition: background .15s, color .15s;
    }
    .nav-item:hover { color: var(--text-muted); }
    .nav-item.active { background: var(--accent-tint); color: var(--accent); }
    .nav-item.active svg { stroke-width: 2.1; }
  `],
})
export class MobileNavComponent {
  protected readonly authService = inject(AuthService);
  protected readonly profileLink = computed(() => (this.authService.isLoggedIn() ? '/profil' : '/autentificare'));
}
